import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { Injectable } from '@angular/core';
import { LoadingService } from '@digiwall/core';
import { concatMap, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocPricingService {
  constructor(
    private confirmationService: ConfirmationService,
    private loadingService: LoadingService,
  ) {}

  public recomputePrices(
    docId: string,
    docService: {
      recomputePrices: (docId: string) => Observable<void>;
    },
    callback: () => void,
  ): void {
    const computationResult = this.confirmationService
      .warn('Doc::RecomputePricesBasedOnArticlePrices', '::AreYouSure')
      .pipe(
        concatMap(confirmationResult => {
          if (confirmationResult != Confirmation.Status.confirm) {
            return;
          }

          return docService.recomputePrices(docId);
        }),
      );

    this.loadingService.interceptNextRequest();
    computationResult.subscribe(() => {
      callback && callback();
    });
  }
}
